import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button, Label, Input, FormGroup } from 'reactstrap';

import { getToastMsg } from '../../../ErrorMessage';
import {
  patchOverviewEdits,
  updateOverviewEdits,
} from '../../../../redux/actions/overviewEditorActions';
import { closeOverviewModal } from '../../../../redux/actions/trekOverviewActions';

const ENTER_KEY = 13;


class TrekCTAAndPriceEditor extends Component {
  state = {
    description: this.props.description ? this.props.description : '',
    ctaUrl: this.props.ctaUrl ? this.props.ctaUrl : '',
    staticPriceNPR: this.props.staticPriceNPR ? this.props.staticPriceNPR : '',
    staticPriceINR: this.props.staticPriceINR ? this.props.staticPriceINR : '',
    staticPriceUSD: this.props.staticPriceUSD ? this.props.staticPriceUSD : '',
    usdInclusions: this.props.usdInclusions ? this.props.usdInclusions : '',
    inrInclusions: this.props.inrInclusions ? this.props.inrInclusions : '',
    nprInclusions: this.props.nprInclusions ? this.props.nprInclusions : '',
    isSaving: false,
  };

  setDescription = e => this.setState({ description: e.target.value });
  setCTAUrl = e => this.setState({ ctaUrl: e.target.value });
  setStaticPriceNPR = e => this.setState({ staticPriceNPR: e.target.value });
  setStaticPriceINR = e => this.setState({ staticPriceINR: e.target.value });
  setStaticPriceUSD = e => this.setState({ staticPriceUSD: e.target.value });

  setUsdInclusions = e => this.setState({ usdInclusions: e.target.value });
  setInrInclusions = e => this.setState({ inrInclusions: e.target.value });
  setNprInclusions = e => this.setState({ nprInclusions: e.target.value });


  render() {
    const { isSaving, ctaUrl, staticPriceNPR, staticPriceINR, staticPriceUSD, usdInclusions, inrInclusions, nprInclusions } = this.state;
    const { closeOverviewModal } = this.props;

    return (
      <div>
        <div className="d-mobile">
          <div className="d-flex justify-content-between border-bottom mb-3">
            <h2>EDIT INCLUSIONS, TREK PRICE, CTA URL</h2>
            <a onClick={closeOverviewModal}>
              <i className="icon icon-hg-cross" aria-hidden="true" />
            </a>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12 col-12">
            <FormGroup>
              <Label>USD Inclusions</Label>
              <Input type="textarea" value={usdInclusions} onChange={this.setUsdInclusions} />
            </FormGroup>
            {/* <p className="error">{description ? '' : 'Add a trek summary!'}</p> */}
          </div>
          <div className="col-sm-12 col-12">
            <FormGroup>
              <Label>INR Inclusions</Label>
              <Input type="textarea" value={inrInclusions} onChange={this.setInrInclusions} />
            </FormGroup>
            {/* <p className="error">{description ? '' : 'Add a trek summary!'}</p> */}
          </div>
          <div className="col-sm-12 col-12">
            <FormGroup>
              <Label>NPR Inclusions</Label>
              <Input type="textarea" value={nprInclusions} onChange={this.setNprInclusions} />
            </FormGroup>
            {/* <p className="error">{description ? '' : 'Add a trek summary!'}</p> */}
          </div>
          <div className="col-sm-6 col-12">
            <FormGroup>
              <Label>Price and Currency (USD)</Label>
              <Input value={staticPriceUSD} onChange={this.setStaticPriceUSD} />
            </FormGroup>
            <p className="error">{staticPriceUSD ? '' : 'Example: USD 50,000'}</p>           
          </div>
          <div className="col-sm-6 col-12">
            <FormGroup>
              <Label>Price and Currency (INR)</Label>
              <Input value={staticPriceINR} onChange={this.setStaticPriceINR} />
            </FormGroup>
            <p className="error">{staticPriceINR ? '' : 'Example: INR 50,000'}</p>           
          </div>
          <div className="col-sm-6 col-12">
            <FormGroup>
              <Label>Price and Currency (NPR)</Label>
              <Input value={staticPriceNPR} onChange={this.setStaticPriceNPR} />
            </FormGroup>
            <p className="error">{staticPriceNPR ? '' : 'Example: NPR 50,000'}</p>           
          </div>
          <div className="col-sm-6 col-12">
            <FormGroup>
              <Label>CTA URL</Label>
              <Input value={ctaUrl} onChange={this.setCTAUrl} />
            </FormGroup>
            <p className="error">{ctaUrl ? '' : 'Enter a valid URL'}</p>           
          </div>
        </div>
        <div className="row">
          <div className="col-12 text-center">
            <Button
              onClick={this.save}
              // disabled={!validateTrekName}
              className={isSaving ? 'btn-loading btn-primary' : 'btn-primary'}
            >
              {isSaving ? 'Saving' : 'Save'}
            </Button>
          </div>
        </div>
      </div>
    );
  }

  save = () => {
    let { description, ctaUrl, staticPriceNPR, staticPriceINR, staticPriceUSD, inrInclusions, usdInclusions, nprInclusions } = this.state;
    const {
      trekId,
      patchOverviewEdits,
      closeOverviewModal,
      updateOverviewEdits,
    } = this.props;

    this.setState({ isSaving: true, netWorkError: '' });

    const patchObj = {
      description,
      static_price_npr: staticPriceNPR,
      static_price_inr: staticPriceINR,
      static_price_usd: staticPriceUSD,
      cta_url: ctaUrl,
      npr_inclusions: nprInclusions,
      inr_inclusions: inrInclusions,
      usd_inclusions:  usdInclusions,
    };

    // SEND TREKNAME AND DATE TO API
    const toastMsgData = '';

    patchOverviewEdits(trekId, patchObj)
      .then(() => {
        
        // UPDATE REDUX STORE WITH THE SAME PATCH OBJECT
        updateOverviewEdits(patchObj);
        this.setState({ isSaving: false });
        closeOverviewModal();
        getToastMsg({ type: 'changeTrekNameDate', status: 'success', data: toastMsgData });
      })
      .catch(() => {
        this.setState({ netWorkError: ' Network Error', isSaving: false });
        getToastMsg({ type: 'changeTrekNameDate', status: 'error', data: toastMsgData });
      });
  };

  onBackButtonEvent = e => this.props.closeOverviewModal();

  handleEnterPress = e => {
    if (e.keyCode === ENTER_KEY) {
      // SAVE AND CLOSE ON ENTER
      this.save();
      this.props.closeOverviewModal();
    }
  };
}

const mapStateToProps = ({ selectedTrek }) => ({
  trekId: selectedTrek.trek.id,
  description: selectedTrek.trek.description,
  staticPriceNPR: selectedTrek.trek.static_price_npr,
  staticPriceINR: selectedTrek.trek.static_price_inr,
  staticPriceUSD: selectedTrek.trek.static_price_usd,
  ctaUrl: selectedTrek.trek.cta_url,
  usdInclusions: selectedTrek.trek.usd_inclusions,
  inrInclusions: selectedTrek.trek.inr_inclusions,
  nprInclusions: selectedTrek.trek.npr_inclusions,
});

export default withRouter(
  connect(
    mapStateToProps,
    {
      patchOverviewEdits,
      updateOverviewEdits,
      closeOverviewModal,
    }
  )(TrekCTAAndPriceEditor)
);



// WEBPACK FOOTER //
// ./src/components/TrekDetail/Editors/TrekCTAAndPrice/TrekCTAAndPrice.jsx